import * as React from "react";

interface Props {
  color: string;
  size: number;
  style?: any;
  onClick?: any;
  fillbox?: string;
}

export const PencilIcon = (props: Props) => (
  <svg
    width={props.size}
    height={props.size}
    fill="none"
    viewBox={props.fillbox}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m11.707 4.54-8.504 8.525-.515 1.248 1.247-.516 8.525-8.504-.753-.753ZM13.409 2.839l-.369.368.753.753.369-.368a.516.516 0 0 0 0-.73l-.024-.023a.516.516 0 0 0-.73 0Z"
      stroke={props.color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
